var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"netbanner",attrs:{"data-show":_vm.visible ? '' : null,"role":"status","aria-live":"polite"}},[_c('base-icon',{attrs:{"name":"wifi-off","width":2.2}}),_c('span',[_vm._v("اتصال اینترنت برقرار نیست")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }